import Modally from "../modally.mjs";

if (!window.Modally) {
  window.Modally = Modally;
}
